import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    skillAcquisitionDomainActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_SKILLACQUISITIONDOMAIN_LIST_API, 
    POST_SKILLACQUISITIONDOMAIN_API, 
    DELETE_SKILLACQUISITIONDOMAIN_API,
    GET_SKILLACQUISITIONDOMAIN_DETAIL_API,
    POST_MASTER_DOMAIIN_DETAILS_LIST_API,
    GET_SKILLACQUISITIONARCHIVEDDOMAIN_LIST_API,
    GET_SKILLACQUISITIONARCHIVEDPROGRAM_LIST_API,
    GET_SKILLACQUISITIONARCHIVEDTARGET_LIST_API,
    GET_DOMAIN_LIST_API,
    GET_PROGRAM_LIST_API,
    COPY_PATIENT_SKILLACQUISITION_DATA,
    GET_SKILLACQUISITIONPROGRAM_LIST_API,
    MOVE_PATIENT_SKILLACQUISITION_DATA,
    GET_SKILLACQUISITIONPROGRAM_LIST_MOVE_API
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../../actions/utilAction';

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const getSkillAcquisitionDomainList = (searchObj, patientId) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONDOMAIN_LIST_API}${query_params}&patientId=${patientId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionDomainList', error);
            });
    };
};

export const getSkillAcquisitionDomainListDetails = (domainId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainDetail.REQUEST));
        fetch(`${GET_SKILLACQUISITIONDOMAIN_DETAIL_API}?domainId=${domainId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionDomainDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionDomainDetail', error);
            });
    };
};

export const saveSkillAcquisitionDomain = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.save_skillAcquisitionDomain.REQUEST));
        fetch(`${POST_SKILLACQUISITIONDOMAIN_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.save_skillAcquisitionDomain.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.save_skillAcquisitionDomain.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_skillAcquisitionDomain', error);
            });
    };
};

export const deleteSkillAcquisitionDomain = (domainId, patientId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.delete_skillAcquisitionDomain.REQUEST));
        fetch(`${DELETE_SKILLACQUISITIONDOMAIN_API}?domainId=${domainId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.delete_skillAcquisitionDomain.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText:  null },
                        pageNumber: 1,
                    };
                    dispatch(getSkillAcquisitionDomainList(searchObj, patientId))
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.delete_skillAcquisitionDomain.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.delete_skillAcquisitionDomain.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_skillAcquisitionDomain', error);
            });
    };
};


export const saveMasterDomainById = (formProps,patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_masterDomainDetails.REQUEST));
        fetch(`${POST_MASTER_DOMAIIN_DETAILS_LIST_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_masterDomainDetails.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText:  null },
                        pageNumber: 1,
                    };
                    dispatch(getSkillAcquisitionDomainList(searchObj, patientId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_masterDomainDetails.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error post_masterDomainDetails', error);
            });
    };
};


export const getSkillAcquisitionArchvedDomainList = (patientId) => {
    
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedDomainList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONARCHIVEDDOMAIN_LIST_API}?patientId=${patientId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedDomainList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedDomainList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionDomainList', error);
            });
    };
};

export const getSkillAcquisitionArchivedProgramList = (patientId, skillsAcquisitionDomainId) => {
    
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedProgramList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONARCHIVEDPROGRAM_LIST_API}?patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedProgramList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedProgramList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionDomainList', error);
            });
    };
};


export const getSkillAcquisitionArchivedTargetList = (patientId, skillsAcquisitionProgramId) => {
    
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedTargetList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONARCHIVEDTARGET_LIST_API}?patientId=${patientId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedTargetList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionArchivedTargetList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionDomainList', error);
            });
    };
};

export const getDomainList = (searchObj, curriculumLibraryIdForDomain, isAllRecordsRequired) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_domainList.REQUEST));
      let query_params = createSearchUrlForCustomAPI(searchObj);
      fetch(`${GET_DOMAIN_LIST_API}${query_params}&curriculumLibraryId=${curriculumLibraryIdForDomain}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
        method: 'GET',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_domainList.SUCCESS, response));
          } else {
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_domainList.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error get_domainList ', error);
        });
    };
  };

  export const getProgramList = (searchObj, domainId, isAllRecordsRequired) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_programList.REQUEST));
      let query_params = createSearchUrlForCustomAPI(searchObj);
      fetch(`${GET_PROGRAM_LIST_API}${query_params}&domainId=${domainId}&isAllRecordsRequired=${isAllRecordsRequired}`, {
        method: 'GET',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_programList.SUCCESS, response));
          } else {
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_programList.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error get_programList ', error);
        });
    };
  };

  export const copyPatientSkillAcquisitionData = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_patientSkillAcquisitionData.REQUEST));
        fetch(`${COPY_PATIENT_SKILLACQUISITION_DATA}`,{
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
         })
        .then(checkHttpStatus)
        .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message)
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_patientSkillAcquisitionData.SUCCESS, response));
        } else if (response.statusCode === 409){
            showWarningMessage(response.message);
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_patientSkillAcquisitionData.SUCCESS, null));
        } else {
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.post_patientSkillAcquisitionData.SUCCESS, null));
        }
        })
        .catch(function(error) {
        console.log('error get_programList ', error);
        });
    };
  }
  export const getSkillAcquisitionProgramList = (searchObj, patientId, skillsAcquisitionDomainId, isAllRecordsRequired) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramList.REQUEST));
        fetch(`${GET_SKILLACQUISITIONPROGRAM_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionProgramList', error);
            });
    };
};
  export const getSkillAcquisitionProgramListForMoveData = (searchObj, patientId, skillsAcquisitionDomainId, isAllRecordsRequired) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMove.REQUEST));
        fetch(`${GET_SKILLACQUISITIONPROGRAM_LIST_MOVE_API}${query_params}&patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMove.SUCCESS, response));
                } else {
                    dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMove.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionProgramListForMove', error);
            });
    };
};
export const movePatientSkillAcquisitionData = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.move_patientSkillAcquisitionData.REQUEST));
        fetch(`${MOVE_PATIENT_SKILLACQUISITION_DATA}`,{
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
         })
        .then(checkHttpStatus)
        .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message)
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.move_patientSkillAcquisitionData.SUCCESS, response));
        } else {
            dispatch(actionCreator(skillAcquisitionDomainActionTypes.move_patientSkillAcquisitionData.SUCCESS, null));
        }
        })
        .catch(function(error) {
        console.log('error get_programList ', error);
        });
    };
  }

  export const ResetMoveData = () => {
    return (dispatch) => {
        dispatch(actionCreator(skillAcquisitionDomainActionTypes.get_skillAcquisitionProgramListForMoveReset.SUCCESS, 0));
    }
  }




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/actions/skillAquisitionDomainActions.js